import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Select,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { preference } from "../../../../utils/tenants";
import { collection, doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import FormAction from "../../../../components/common/FormAction";

function FederalTax({ data, peopleType, renderData, companyName }) {
  const [checked, setChecked] = useState(false);
  // const [receiveElectronic, setreceiveElectronic] = useState(true);
  // const [sendingPreference, setsendingPreference] = useState('paper');

  const defaultValues = {
    taxPayerName: data?.taxPayerName ? data?.taxPayerName : " ",
    taxPayerId: data?.taxPayerId ? data?.taxPayerId : "-",
    companyTaxpayer: data?.companyTaxpayer ? data?.companyTaxpayer : "-",
    useCompanyName: data?.useCompanyName ? data?.useCompanyName : false,
    send099: data?.send099 ? data?.send099 : false,
    receiveElectronic: data?.receiveElectronic
      ? data?.receiveElectronic
      : false,
    sendingPreference: data?.sendingPreference ? data?.sendingPreference : "",
  };

  const [disableCompanyNameEdit, setDisableCompanyNameEdit] = useState(
    defaultValues.useCompanyName
  );
  const [send109Checkbox, setSend109Checkbox] = useState(data?.send099);

  // const [form] = Form.useForm();
  const { id } = useParams();

  // console.log("Federal Tax Federal Tax", data)

  const onFinish = async (values) => {
    //console.log("Federal Tax success", values);
    // form.setFieldsValue(values);
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const ownerRef = collection(companyDocRef, "owners");
    console.log(id);

    try {
      await updateDoc(doc(ownerRef, id), {
        federalTax: values,
      });

      message.success("Federal Tax data Updated SuccessFully!");
      setChecked(false);
      renderData(true);
    } catch (err) {
      console.error(err);
      message.error(err.message);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Federal Tax data Update Failed!");
  };

  const onCancel = () => {
    setChecked(false);
  };

  useEffect(() => {
    if (defaultValues.useCompanyName) {
      setDisableCompanyNameEdit(true);

      console.log("running");
    } else {
      setDisableCompanyNameEdit(false);
      console.log("running not ");
    }
  }, []);

  useEffect(() => {
    if (data?.send099) {
      setSend109Checkbox(true);
    } else {
      setSend109Checkbox(false);
      console.log(defaultValues.send099, "defaultValues.send099");
      console.log("running not ");
    }
  }, [data?.send099]);
  const handleCompanyNameChange = (e) => {
    setDisableCompanyNameEdit(e.target.checked);
  };
  const handleSend09 = (e) => {
    setSend109Checkbox(e.target.checked);
  };
  return (
    <Row>
      <Col span={24}>
        <Card
          title="Federal Tax"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <div>
              <Form
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 11 }}
                colon={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={defaultValues}
              >
                <Col span={24}>
                  {!disableCompanyNameEdit ? (
                    <Form.Item label="Taxpayer Name" name="taxPayerName">
                      <Input />
                    </Form.Item>
                  ) : (
                    <Form.Item label="Taxpayer Name">
                      <Input disabled value={defaultValues?.taxPayerName} />
                    </Form.Item>
                  )}
                  <Form.Item
                    label="Use company name as display name"
                    name="useCompanyName"
                    valuePropName="checked"
                    onChange={handleCompanyNameChange}
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item label="Taxpayer ID" name="taxPayerId">
                    <Input />
                  </Form.Item>

                  <Form.Item label="Taxpayer Account Number">
                    <p>{data?.companyTaxpayer ? data?.companyTaxpayer : "-"}</p>
                  </Form.Item>

                  <Form.Item
                    label="Send 099?"
                    name="send099"
                    valuePropName="checked"
                    onChange={handleSend09}
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>

                  {peopleType === "Owner" && send109Checkbox ? (
                    <>
                      <Form.Item
                        label="Owner consented to receive electronic 1099?"
                        name="receiveElectronic"
                        valuePropName="checked"
                      >
                        <Checkbox></Checkbox>
                      </Form.Item>
                      <Form.Item
                        label="1099 Sending Preference"
                        name="sendingPreference"
                      >
                        <Select options={preference} placeholder="Select..." />
                      </Form.Item>
                    </>
                  ) : null}
                </Col>
                <FormAction
                  className="contact-actions"
                  submit={"submit"}
                  cancel={onCancel}
                />
              </Form>
            </div>
          ) : (
            <Form
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              colon={false}
            >
              <Form.Item label="Taxpayer Name">
                <p>{data?.taxPayerName ? data?.taxPayerName : "-"}</p>
              </Form.Item>
              <Form.Item label="Taxpayer ID">
                <p>{data?.taxPayerId ? data?.taxPayerId : "-"}</p>
              </Form.Item>
              <Form.Item label="Taxpayer Account Number">
                <p>{data?.companyTaxpayer ? data?.companyTaxpayer : "-"}</p>
              </Form.Item>
              {!send109Checkbox && (
                <Form.Item label="Send 1099?">
                  <p>No</p>
                </Form.Item>
              )}

              {send109Checkbox && (
                <Form.Item label="Send 1099?">
                  <p>Yes</p>
                </Form.Item>
              )}
              {peopleType === "Owner" && send109Checkbox ? (
                <>
                  <Form.Item label="Owner consented to receive electronic 1099?">
                    <p>{data?.receiveElectronic ? "Yes" : "No"}</p>
                  </Form.Item>
                  <Form.Item label="1099 Sending Preference">
                    <p>
                      {data?.sendingPreference ? data?.sendingPreference : ""}
                    </p>
                  </Form.Item>
                </>
              ) : null}
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default FederalTax;
